export default __webpack_public_path__ + "static/media/Black pearl_primary.d7202542.jpg";